import { render } from "./associated-requests.vue?vue&type=template&id=466dc339"
import script from "./associated-requests.vue?vue&type=script&lang=js"
export * from "./associated-requests.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__